// extracted by mini-css-extract-plugin
export var questionBox = "_73-0";